<template>
    <div @click="handleSourceClick" class="asset-item-wrap" :class="{ 'is-active': isActive }">
        <!-- 缩率图路径 不存在就显示原图-->
        <el-image v-if="dataType === 'image' && data.imageUrl" class="source-img" :src="data.imageUrl"></el-image>
        <el-image v-else-if="dataType === 'image' && data.url" class="source-img" :src="data.url"></el-image>
        <video
            v-else-if="dataType === 'video'"
            ref="video"
            controls
            :src="data.url"
            class="source-img"
        ></video>
        <!-- <div class="play-btn" @click="play"></div> -->
        <!--  -->
        <div class="status-btn" v-if="showCheck">
            <i class="el-icon-success" style="color: #3de595"></i>
        </div>
        <div class="delete-btn" @click.stop="handleDelete">
            <i class="el-icon-delete"></i>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        data: {
            type: Object,
            default() {
                return {};
            },
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        showCheck() {
            let checkStatus = this.data.checkStatus;
            let flag = `${checkStatus}` === '2';
            return flag;
        },
        imageSrc() {
            let src = '';
            if (this.dataType === 'image') {
                // 图片资源
                src = this.data.url;
            } else if (this.dataType === 'video') {
                // 视频资源
                src = this.data.imageUrl;
            }
            return src;
        },
        dataType() {
            let dType = '';
            let type = this.data.type;
            if (this.validImage(type)) {
                dType = 'image';
            } else if (this.validVideo(type)) {
                dType = 'video';
            }
            // console.log(type);
            // console.log(this.validVideo(type));
            return dType;
        },
    },
    methods: {
        handleSourceClick() {
            this.$emit('click');
        },
        validImage(type) {
            const pattern = /^image\/[a-zA-Z]{0,}/gi;
            return pattern.test(type);
        },
        validVideo(type) {
            const pattern = /^video\/[a-zA-Z0-9]{0,}/gi;
            return pattern.test(type);
        },
        handleDelete() {
            this.$emit('delete');
        },
        play() {
            if (this.$refs.video) {
                if (this.$refs.video.paused === true) {
                    this.$refs.video.play();
                }
            }
        },
        pause() {
            if (this.$refs.video) {
                this.$refs.video.pause();
            }
        },
    },
    created() {},
    mounted() {},
    watch: {
        isActive(val) {
            if (!val) {
                this.pause();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.asset-item-wrap {
    cursor: pointer;
    position: relative;
    border: 3px solid transparent;
    box-sizing: border-box;
    video {
        background: #000;
    }
    .source-img {
        width: 252px;
        height: 192px;
    }
    // &::after {
    //     content: '';
    //     border: 3px solid transparent;
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     bottom: 0;
    //     right: 0;
    // }
    .status-btn {
        background: rgba(3, 5, 61, 0.5);
        width: 18px;
        height: 18px;
        position: absolute;
        top: 3px;
        left: 3px;
        text-align: center;
        line-height: 18px;
    }
    .delete-btn {
        background: rgba(3, 5, 61, 0.5);
        width: 18px;
        height: 18px;
        position: absolute;
        top: 3px;
        right: 3px;
        color: #fff;
        z-index: 100;
    }
    .play-btn {
        display: inline-block;
        width: 56px;
        height: 56px;
        background-image: url('./images/play.png');
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
.is-active {
    border-color: #2e7df8;
    // &::after {
    //     border-color: #2e7df8;
    // }
}
</style>
